module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAABFklEQVQ4T+2UsUoEMRCG/8lCrNYLV4uNLxDIE4hvYamVlr6A4ENoZetTyLkPsJPK0kawFRUEz4XNSMRwOdlwq4edU2WYyTeTmckQFqKstZuZXjwaY+ZN08xzB4qKc24fwDmAyRgQgLe6rqc5LIIq59wjER2KyPUIUAx2D8Aw80vyJ2utqarq6buhBBzwVwDCWiCtddd13YPWemstUN/3lF7zD1r0MO/an9fogojeVw2kiGwAOIpzV8poFCgGCiE8e+/PrLWTwfYD2AawU8qKiO7atr1N9rxeS3MkIqdEtFsCiciN9/5kEJQ+rYgchBBmq2q0tDqI9pRSl8w8/e0aSbz4+4+Z+eoT9CXKOVf/JCNmfgXQxzsflbyuWcjS+00AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/public/img/shop3.png
// module id = USfN
// module chunks = 27